/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures200,
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures401,
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures404,
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures500,
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesPathParams,
  GetApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesQueryResponse,
} from "../../types/courseFinancialLangsController/GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCultures200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCultures401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCultures404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCultures500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCultures500>;

export const getApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CoursefinancialCoursefinancialidLangsAvailableCultures200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsAvailableCulturesQueryResponse>;
